import React, { useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { Auth } from 'aws-amplify'
import { useAlert } from 'react-alert'

import { settings } from '../../../../main/configs/settings'
import { fetchMe } from '../../../../main/usecases'

import { useForm } from '../../../hooks'
import { goToUrl, setUser, exceptionsError } from '../../../utils'
import { Button, Input, InputPassword } from '../../../components'
import { CardContainer } from '../../../components/ui/components'

import { FullLogoSvg } from '../../../assets/icons/svgComponents'

import * as S from './styles'

const Signin = () => {
  const [loading, setLoading] = useState(false)
  const history = useHistory()
  const alert = useAlert()
  const email = useForm('email')
  const password = useForm()

  const onSubmit = async (event: React.FormEvent) => {
    event.preventDefault()

    if (email.value && password.value) {
      try {
        setLoading(true)
        await Auth.signIn(email.value.trim().toLowerCase(), password.value)
        const me = await fetchMe().load()
        await setUser(me)

        goToUrl(history, settings.dashboardRoute)
      } catch (error: any) {
        alert.show(exceptionsError(error.code, error.message), {
          type: 'error',
          timeout: 4000
        })
      } finally {
        setLoading(false)
      }
    }
  }

  return (
    <S.Wrapper>
      <CardContainer style="container" backgroundColor="#017849">
        <S.Content>
          <FullLogoSvg />
          <S.Subtitle>psi</S.Subtitle>
          <form onSubmit={onSubmit}>
            <Input label="Email" type="email" name="email" {...email} />
            <InputPassword
              label="Senha"
              name="password"
              topEyer="37px"
              topEyerBlock="35px"
              {...password}
            />
            <Link className="forget-password-link" to="/esqueceu-senha">
              Esqueci a senha
            </Link>
            {loading ? (
              <Button disabled>Entrando...</Button>
            ) : (
              <Button>Entrar</Button>
            )}
          </form>
          <Link className="register-link" to="/cadastro">
            Cadastre-se gratuitamente
          </Link>
        </S.Content>
      </CardContainer>
    </S.Wrapper>
  )
}
export default Signin
